module.exports = __webpack_public_path__ + "static/step-2-bug.2c7559ee.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/quickstart/websockets/step-2-bug.png
// module id = 2572
// module chunks = 108498221076391